import { useDispatch } from 'react-redux'
import { openInviteMemberDialog } from '~workspace/states/ui'
import { useIsWorkspaceOwner } from '~workspace/states/workspace'
import View from './view'

const MembersTabTools = () => {
  const dispatch = useDispatch()
  const isWorkspaceOwner = useIsWorkspaceOwner()

  const handleInviteMemberClick = () => {
    dispatch(openInviteMemberDialog())
  }

  return (
    <View
      canInviteMember={isWorkspaceOwner}
      onInviteMemberClick={handleInviteMemberClick}
    />
  )
}

export { MembersTabTools }
export default MembersTabTools
